export default "__VITE_ASSET__lDY0lpjj__"